import {findKey} from '../../../lib/utilities';
import { SpeedIndexAbsoluteValues } from '../../_constants/speed_value_absolute_values';

function getSpeedIndexAbsoluteValue(speedIndex) {
    return findKey(SpeedIndexAbsoluteValues, (speedRepresentation) => speedRepresentation === speedIndex);
}

export { getSpeedIndexAbsoluteValue };